import { useGetSalesPromoList } from '../../providers/SalesPromo.provider';

export function useSalesPromoHooks() {

  const salesPromoList = useGetSalesPromoList();

  return {
    salesPromoList
  };
}
